module.exports = __webpack_public_path__ + "static/media/pressure-monitor-info-alert.abd9528b.svg";